export enum PublicUrls {
  Ship = "Public/Ship",
  Requester = "Public/Requester",
  Category = "Public/Category",
  Currency = "Public/Currency",
  AllCurrency = "Public/AllCurrency",
}
